import React, { useState, useEffect } from 'react';
import navbarConfig from '../navbarConfig.json'; // Import the JSON config file
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const defaultNavItems = [];
const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [siteConfig, setSiteConfig] = useState(null);

    useEffect(() => {
        const fetchSiteConfig = async () => {
            try {
                const docRef = doc(db, 'content', 'site');
                const snap = await getDoc(docRef);
                if (snap.exists()) {
                    setSiteConfig(snap.data());
                }
            } catch (err) {
                console.error('Failed to load site config for navbar:', err);
            }
        };
        fetchSiteConfig();
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const logo = siteConfig?.logo || navbarConfig.logo;
    const title = siteConfig?.title || navbarConfig.title;
    const navItems = (Array.isArray(siteConfig?.navItems) ? siteConfig.navItems : navbarConfig.navItems) || defaultNavItems;

    return (
        <nav style={{ backgroundColor: siteConfig?.colors?.navbarBackground || '#1f2937' }} className="p-4">
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex items-center space-x-4">
                    <img src={logo.url} alt={logo.alt} className="rounded-full" width={'55px'} />
                    <span className="text-white text-lg font-bold">{title}</span>
                </div>
                <div className="hidden md:flex space-x-6">

                    {navItems.map((item, index) => (
                        <a key={index} href={item.href} className="text-gray-300 hover:text-white">{item.text}</a>
                    ))}
                </div>
                <div className="md:hidden">
                    <button onClick={toggleMenu} className="text-gray-300 hover:text-white focus:outline-none">

                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </button>
                </div>
            </div>
            {isOpen && (
                <div className="md:hidden mt-4">

                    {navItems.map((item, index) => (
                        <a
                            key={index}
                            href={(item.href || '').startsWith('http') ? item.href : (item.href || '').startsWith('#') ? item.href : `https://${item.href}`}
                            className="block text-gray-300 hover:text-white px-4 py-2"
                        >
                            {item.text}
                        </a>
                    ))}
                </div>
            )}
        </nav>
    );
};

export default Navbar;